<template>
    <input
        v-bind="$attrs"
        :class="['form-control', size && `form-control-${size}`]"
        :type="type"
        :value="currentValue"
        :disabled="disabled"
        @input="update($event.target.value)"
        @change="$emit('change', $event.target.value)"
    >
</template>
<script>
import { emitModel } from "./model";
export default {
    name: "SbFormInput",
    emits: ["update:modelValue", "change"],
    inheritAttrs: false,
    props: {
        modelValue: { default: undefined },
        type: { type: String, default: "text" },
        size: { type: String, default: null },
        disabled: { type: Boolean, default: false },
        debounce: { type: [Number, String], default: 0 },
    },
    data() { return { debounceTimer: null }; },
    computed: { currentValue() { return this.modelValue; } },
    beforeUnmount() { clearTimeout(this.debounceTimer); },
    methods: {
        update(value) {
            clearTimeout(this.debounceTimer);
            const delay = Number(this.debounce) || 0;
            if (delay > 0) { this.debounceTimer = setTimeout(() => emitModel(this, value), delay); }
            else { emitModel(this, value); }
        },
    },
};
</script>
